import { CustomMetaTitle } from 'Components';
import { ExpenseClaimContextProvider } from 'Context/ExpenseClaimContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { ExpenseClaimMain } from './ExpenseClaimMain';

interface IExpenseClaim {
  nextStep: () => void;
  currentStepIndex: number;
  stepsLength: number;
}

export const ExpenseClaim = ({
  nextStep,
  currentStepIndex,
  stepsLength,
}: IExpenseClaim) => {
  return (
    <>
      <CustomMetaTitle
        title={`${Dictionary[DICTIONARY.ExpenseClaim].pageTitle} ${Dictionary[
          DICTIONARY.Requests
        ].stepperSrLabel(currentStepIndex, stepsLength)}`}
      />
      <ExpenseClaimContextProvider>
        <ExpenseClaimMain nextStep={nextStep} />
      </ExpenseClaimContextProvider>
    </>
  );
};
